import { useState } from 'react';
import { TextField, Button, Stack, Link as MuiLink, Box, Alert } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import AuthShell from '../components/AuthShell';
import api from '../utils/axios';
import { getErrorMessage, buildErrorSnackbarOptions } from '../utils/errorUtils';

export default function RequestReset() {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [email, setEmail] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [sent, setSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            enqueueSnackbar('Courriel requis', { variant: 'error' });
            return;
        }
        setSubmitting(true);
        try {
            await api.post('/b2b/auth/reset-request', { email: email.trim() });
            setSent(true);
        } catch (err) {
            enqueueSnackbar(getErrorMessage(err, 'Demande impossible'), buildErrorSnackbarOptions(err, closeSnackbar));
        } finally {
            setSubmitting(false);
        }
    };

    if (sent) {
        return (
            <AuthShell title="Vérifiez votre courriel">
                <Alert severity="success" sx={{ mb: 2 }}>
                    Si un compte existe pour ce courriel, un lien de réinitialisation vient d'être envoyé. Le lien est valide 30 minutes.
                </Alert>
                <MuiLink component={RouterLink} to="/login">← Retour à la connexion</MuiLink>
            </AuthShell>
        );
    }

    return (
        <AuthShell title="Mot de passe oublié?" subtitle="Entrez votre courriel. Si un compte existe, vous recevrez un lien pour réinitialiser.">
            <Box component="form" onSubmit={handleSubmit} noValidate>
                <Stack spacing={2}>
                    <TextField
                        label="Courriel"
                        type="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <Button type="submit" variant="contained" size="large" disabled={submitting}>
                        {submitting ? 'Envoi…' : 'Envoyer le lien'}
                    </Button>
                    <MuiLink component={RouterLink} to="/login" sx={{ alignSelf: 'center', fontSize: 13 }}>
                        ← Retour à la connexion
                    </MuiLink>
                </Stack>
            </Box>
        </AuthShell>
    );
}
